var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-6" }, [
      _c("table", { staticClass: "table enquiry-detail" }, [
        _c(
          "tbody",
          _vm._l(_vm.fields, function(config, field) {
            return _c("tr", [
              _c("td", [_vm._v(_vm._s(config.label))]),
              _vm._v(" "),
              _c("td", {
                domProps: {
                  innerHTML: _vm._s(
                    config.value(_vm._.get(_vm.messageData, field), _vm.__)
                  )
                }
              })
            ])
          }),
          0
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-6" },
      [
        _vm.initialized
          ? _c("table-component", {
              attrs: {
                content: _vm.statuses,
                timestamp: _vm.timestamp,
                selected: _vm.selected,
                config: _vm.statusesConfig,
                query: _vm.query,
                getData: _vm.getData,
                createData: _vm.modifiedCreateData,
                updateBatch: _vm.modifiedUpdateBatch,
                addNotification: _vm.addNotification,
                changeQuery: _vm.doNothing,
                changeUrl: _vm.doNothing,
                onInitialized: _vm.doNothing,
                onSelected: _vm.doNothing
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09eeadbc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09eeadbc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/cms/js/components/MessageDetailComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-09eeadbc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/cms/js/components/MessageDetailComponent.vue
// module chunks = 0